import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Estimativa } from '../models/estimativa.model';
import { Page } from '../models/page.model';
import { PainelGeral } from '../models/painel-geral.model';
import { FilterEstimativa } from '../models/filter/filter-estimativa';
import { EstimativaColaborador } from '../models/estimativa-gerenciar-colaborador';
import { Duplicar } from '../models/duplicar';
import { DeletarEstimativa } from '../models/deletar-estimativa.model';

@Injectable({
  providedIn: 'root'
})
export class EstimativaService extends BaseService<Estimativa> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/estimativa`, injector);
  }

  pesquisar(estimativa: FilterEstimativa, minhasEstimativasIsChecked?: boolean): Observable<Page<Estimativa>> {
    return this.http.post<Page<Estimativa>>(`${environment.API_PRICE}/estimativa/pesquisar?minhasEstimativasIsChecked=${minhasEstimativasIsChecked}`, estimativa);
  }

  pesquisarSimulacao(estimativa: FilterEstimativa, minhasEstimativasIsChecked?: boolean): Observable<Page<Estimativa>> {
    const flag = minhasEstimativasIsChecked === true ? 'true' : 'false';
    return this.http.post<Page<Estimativa>>(
      `${environment.API_PRICE}/estimativa/pesquisar?minhasEstimativasIsChecked=${flag}`,
      estimativa
    );
  }

  pesquisarAprovacao(estimativa: Estimativa): Observable<Page<Estimativa>> {
    return this.http.post<Page<Estimativa>>(`${environment.API_PRICE}/estimativa/pesquisar-aprovacao`, estimativa);
  }

  dashboard(usuarioId: number): Observable<PainelGeral> {
    return this.http.get<PainelGeral>(`${environment.API_PRICE}/estimativa/painel-geral/${usuarioId}`);
  }

  getByUsuarioId(usuarioId: number, statusId: number): Observable<Page<Estimativa>> {
    return this.http.get<Page<Estimativa>>(`${environment.API_PRICE}/estimativa/getByUsuarioId/${usuarioId}/${statusId}`);
  }

  duplicar(duplicar: Duplicar) {
    return this.http.post(`${environment.API_PRICE}/estimativa/duplicar`, duplicar);
  }

  retornarQuantidade(projetoId: number, estimativaId: number): Observable<number> {
    return this.http.get<number>(`${environment.API_PRICE}/estimativa/retornarQuantidade/${projetoId}/${estimativaId}`);
  }

  descartarEstimativas(projetoId: number, estimativaId: number, usuarioId: number) {
    return this.http.get(`${environment.API_PRICE}/estimativa/descartarEstimativas/${projetoId}/${estimativaId}/${usuarioId}`);
  }

  adicionarFaturamentoPreDefinido(estimativaId: number, faturamentoPreDefinidoId: number) {
    return this.http.get(`${environment.API_PRICE}/estimativa/faturamento/pre-definido/${estimativaId}/${faturamentoPreDefinidoId}`);
  }

  // verificarParamsProject(id) {
  //   return this.http.get(`${environment.API_PRICE}/PriceParamProjeto/bs/${id}`);
  // }

  verificarParamsProject(id: number): Observable<string> {
    return this.http.get(`${environment.API_PRICE}/PriceParamProjeto/bs/${id}`, {
      responseType: 'text'
    });
  }

  getColaboradorLista(autocomplete) {
    return this.http.get(`${environment.API_PRICE}/Colaborador/BuscarListaColaboradores/${autocomplete}`);
  }

  gravarComposicaoEquipe(dados: EstimativaColaborador) {
    return this.http.post(`${environment.API_PRICE}/ComposicaoEquipeColaborador/GravarComposicaoEquipeColaborador`, dados);
  }

  getEquipeId(estimativaId) {
    return this.http.get(`${environment.API_PRICE}/Equipe/GetByPropostaId/${estimativaId}`);
  }

  getEquipe(equipeId) {
    return this.http.get(`${environment.API_PRICE}/ComposicaoEquipeColaborador/getByEquipeId/${equipeId}`);
  }

  deleteEquipe(id) {
    return this.http.delete(`${environment.API_PRICE}/ComposicaoEquipeColaborador/${id}`);
  }

  updateC(dados: EstimativaColaborador) {
    return this.http.put(`${environment.API_PRICE}/composicaoequipecolaborador/UpdateComposicaoEquipeColaborador`, dados);
  }

  getEstimativaTipo(estimativaTipo) {
    return this.http.get(`${environment.API_PRICE}/estimativa/${estimativaTipo}`);
  }

  descartarEstimativa(estimativaDeletar: DeletarEstimativa) {
    return this.http.put(`${environment.API_PRICE}/estimativa/descartar-estimativa`, estimativaDeletar)
  }

  reprovarEstimativa(estimativaDeletar: DeletarEstimativa) {
    return this.http.put(`${environment.API_PRICE}/estimativa/reprovar-estimativa`, estimativaDeletar)
  }
}


